import { SupportAccess } from '@channelwill/components'
import { BlockStack } from '@shopify/polaris'

export const SupportComponents = () => {

    return <BlockStack gap="400">
        <SupportAccess componentConfig={{
            baseUrl: process.env.PUBLIC_CHANNELWILL_CGW,
            switchColors: {
                off: '#888888',
                loading: '#9e9e9e'
            }
        }} />
    </BlockStack>
}
